import { render } from "./ReferenceForm.vue?vue&type=template&id=7f5210fd&scoped=true"
import script from "./ReferenceForm.vue?vue&type=script&lang=js"
export * from "./ReferenceForm.vue?vue&type=script&lang=js"

import "./ReferenceForm.vue?vue&type=style&index=0&id=7f5210fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5210fd"]])

export default __exports__